import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApiData } from "../hooks/useApiData";
import "./PageContent.css";
import "./GovtApprovalPage.css";

const BASE_URL = process.env.REACT_APP_API_URL || "http://192.168.0.57:5001/api";

export default function AntiRagingPage() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { data: leaders } = useApiData("leadership");

  const principal = leaders?.find((l) =>
    String(l.role || "").toLowerCase().match(/principal|dean/)
  );
  const medicalSuperintendent = leaders?.find((l) =>
    String(l.role || "").toLowerCase().includes("medical superintendent")
  );

  const slugifyRole = (str) =>
    String(str || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  const renderOfficialMessage = (leader, title) => {
    if (!leader) return null;
    return (
      <div className="official-message-block">
        <div className="official-message-title">{title}</div>
        <div className="official-message-body">
          <div className="official-message-top">
            <div className="official-photo-wrapper">
              <img
                src={leader.img}
                alt={leader.name}
                className="official-photo"
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    leader.name || "Official"
                  )}&background=0b5d7a&color=fff&size=150`;
                }}
              />
            </div>
            <div className="official-message-text">
              <p>{leader.message}</p>
            </div>
          </div>
          <div className="official-name">{leader.name}</div>
          <div className="official-role">{leader.role}</div>
          <div className="official-more-wrapper">
            <Link
              to={`/leadership-message/${slugifyRole(leader.role)}`}
              className="official-more"
            >
              More...
            </Link>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    fetch(`${BASE_URL}/anti-ragging`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => setContent(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  // Normalize the download form(s) this page can render.
  // Supports either a single attachment (content.attachment) or an array
  // of forms (content.downloadForms), whichever the API sends back.
  const downloadForms = Array.isArray(content?.downloadForms)
    ? content.downloadForms
    : content?.attachment
    ? [
        {
          name: content.attachmentName || "Document",
          link: content.attachment,
        },
      ]
    : [];

  return (
    <main className="content-page-wrapper">
      {/* =====================================================
          BREADCRUMB
          ===================================================== */}
      <div className="content-breadcrumb-wrapper">
        <div className="content-container">
          <div className="content-breadcrumb">
            <Link to="/">
              <i className="fa fa-home"></i>
              Home
            </Link>
            <span className="breadcrumb-arrow">
              <i className="fa fa-angle-right"></i>
            </span>
            <span className="breadcrumb-current">Anti Ragging</span>
          </div>
        </div>
      </div>

      {/* =====================================================
          MAIN CONTENT
          ===================================================== */}
      <div className="content-container">
        <div className="content-layout">

          {/* =================================================
              LEFT SIDEBAR
              ================================================= */}
          <aside className="content-sidebar">
            <div className="official-info-card">
              <div className="official-info-header">
                <div className="official-info-icon">
                  <i className="fa fa-envelope-o"></i>
                </div>
                <span>MESSAGE FROM</span>
              </div>
              <div className="official-info-body">
                {renderOfficialMessage(principal, "DEAN AND PRINCIPAL")}
                {renderOfficialMessage(medicalSuperintendent, "MEDICAL SUPERINTENDENT")}
              </div>
            </div>
          </aside>

          {/* =================================================
              RIGHT MAIN CONTENT
              ================================================= */}
          <section className="content-main-card">

            <h1 className="notice-page-title">
              ANTI RAGGING
            </h1>

            {error && (
              <p className="ql-error">
                <i className="fa fa-exclamation-circle" aria-hidden="true" /> Could not load content
              </p>
            )}

            {loading ? (
              <div className="content-loading">
                <div className="content-spinner"></div>
                <p>Loading...</p>
              </div>
            ) : content ? (
              <React.Fragment>
                {content.img && (
                  <img
                    src={content.img}
                    alt={content.title}
                    style={{ maxWidth: "100%", borderRadius: 5, marginBottom: 18 }}
                  />
                )}

                <div
                  className="page-html-content"
                  dangerouslySetInnerHTML={{ __html: content.detailsHtml }}
                />

                {/* =================================================
                    DOWNLOAD FORM(S)
                    Styled the same as GovtApprovalPage's document
                    buttons (govt-approval-doc-link / -color-N), so it
                    visually matches that page's attachment pills
                    instead of the single "View Document" button.
                    ================================================= */}
                {downloadForms.length > 0 && (
                  <div className="content-attachment-section">
                    <div className="attachment-heading">
                      <i className="fa fa-paperclip"></i>
                      Download Documents{downloadForms.length > 1 ? "s" : ""}
                    </div>

                    <div className="govt-approval-doc-buttons">
                      {downloadForms.map((form, idx) => (
                        <a
                          key={idx}
                          href={form.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`govt-approval-doc-link govt-approval-doc-color-${idx % 8}`}
                          title={form.name ? `Open ${form.name}` : "Open document"}
                        >
                          <i className="fa fa-file-pdf-o" style={{ marginRight: 6 }}></i>
                          {form.name || `Form ${idx + 1}`}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </React.Fragment>
            ) : (
              <div className="content-not-found">
                <div className="not-found-icon">
                  <i className="fa fa-exclamation-triangle"></i>
                </div>
                <h2>Content Not Found</h2>
                <p>Anti Ragging information is not available right now.</p>
                <Link to="/" className="back-home-btn">
                  <i className="fa fa-home"></i> Back to Home
                </Link>
              </div>
            )}
          </section>

        </div>
      </div>
    </main>
  );
}
